import React, {useMemo} from 'react'
import {Row, Col, Button} from 'react-bootstrap'
import {useSelector} from 'react-redux'
import {getAllUserDetails} from '../Overview/OverviewSlice/UserDetailsSlice'

interface CreditCardProps {
  title: string
  balance: string | number
  actionText: string
  onAction: () => void
}

const CreditCard: React.FC<CreditCardProps> = ({title, balance, actionText, onAction}) => {
  return (
    <Col lg={3} md={6} className='mb-4'>
      <div className='card h-100 shadow-sm border-0' style={{borderRadius: '12px'}}>
        <div className='card-body p-4 text-start'>
          <h6 className='text-muted mb-3 fw-semibold'>{title}</h6>
          <h2 className='fw-bold mb-3 text-dark'>{balance}</h2>
          <Button
            variant='link'
            className='p-0 text-decoration-none fw-semibold'
            onClick={onAction}
            style={{color: '#7c3aed'}}
          >
            {actionText}
          </Button>
        </div>
      </div>
    </Col>
  )
}

const CreditsBalances: React.FC = () => {
  const rootData: any = useSelector((state: any) => state?.userDetails?.userDetails?.data)

  const creditCards = useMemo(() => {
    const credits = rootData?.credits || {sms: 0, mms: 0}
    return [
      {
        title: 'SMS',
        balance: credits?.sms ?? 0,
        actionText: '',
        onAction: () => console.log('SMS clicked'),
      },
      {
        title: 'MMS',
        balance: credits?.mms ?? 0,
        actionText: '',
        onAction: () => console.log('MMS clicked'),
      },
    ]
  }, [rootData])

  return (
    <div className='card mb-5 mb-xl-10'>
      <div className='card-header border-0 pt-5'>
        <h3 className='card-title align-items-start flex-column'>
          <span className='card-label fw-bold fs-3 mb-1'>CREDITS & BALANCES</span>
          <span className='text-muted mt-1 fw-semibold fs-7'>
            Manage your credit balances and top-ups
          </span>
        </h3>
      </div>

      <div className='card-body py-3'>
        <Row>
          {creditCards.map((card, index) => (
            <CreditCard
              key={index}
              title={card.title}
              balance={card.balance}
              actionText={card.actionText}
              onAction={card.onAction}
            />
          ))}
        </Row>
      </div>
    </div>
  )
}

export default CreditsBalances
